import { useState, useEffect } from "react";
import { galleryImages } from "@/mocks/news";

const GallerySection = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % galleryImages.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative py-0 overflow-hidden">
      <div className="w-full overflow-hidden leading-none">
        <svg viewBox="0 0 1440 120" className="w-full" preserveAspectRatio="none" style={{ height: 80 }}>
          <path d="M0,60 C360,120 1080,0 1440,60 L1440,120 L0,120 Z" fill="#15803d" />
        </svg>
      </div>

      <div className="bg-green-700 py-8 lg:py-16 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8">
            <p className="text-green-200 text-xs font-semibold tracking-widest mb-2">Gallery</p>
            <h2 className="text-white text-2xl lg:text-3xl font-bold">施設のようす</h2>
          </div>
          <div className="relative rounded-2xl lg:rounded-3xl overflow-hidden aspect-video">
            {galleryImages.map((src, i) => (
              <div
                key={src}
                className={`absolute inset-0 transition-opacity duration-1000 ${
                  i === current ? "opacity-100" : "opacity-0"
                }`}
              >
                <img src={src} alt="" className="w-full h-full object-cover object-top" />
              </div>
            ))}
          </div>

          <div className="flex justify-center gap-2 mt-6">
            {galleryImages.map((_, i) => (
              <button
                key={i}
                type="button"
                onClick={() => setCurrent(i)}
                className={`h-2 rounded-full transition-all cursor-pointer ${
                  i === current ? "bg-white w-8" : "bg-white/40 w-2"
                }`}
                aria-label={`画像 ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="w-full overflow-hidden leading-none">
        <svg viewBox="0 0 1440 120" className="w-full" preserveAspectRatio="none" style={{ height: 80 }}>
          <path d="M0,60 C360,0 1080,120 1440,60 L1440,0 L0,0 Z" fill="#15803d" />
        </svg>
      </div>
    </section>
  );
};

export default GallerySection;
